module.exports = __webpack_public_path__ + "static/media/UMAN_figure.a40b088a.jpeg";